












































































































































































































































































import Vue from 'vue'
import { sendValidationCode, checkValidationCode, setPassword, changePassword, loginWithUserPhone } from '@/api/auth'
import * as Auth from '@/interfaces/auth'
import { ISendVCodeRequest, ICheckVCodeRequest, ILoginRequest } from '@/interfaces/auth'
import { mapMutations } from 'vuex'
import Logo from '@/components/Logo.vue'
import { phoneAreaOptions, getCountryCodeByPhoneCode } from '@/utils/data'
import { fbTrack } from '@/utils'

export default Vue.extend({
  name: 'SignUp',
  components: { Logo },
  props: {
    redirect: {
      type: String,
      default: undefined
    },
    isRegister: {
      type: Boolean,
      default: undefined
    }
  },
  data () {
    return {
      transformedPhoneNumber: '' as string,
      phoneNumber: this.$store.state.account.length > 0 ? this.$store.state.account : '' as string,
      vcode: '',
      password: '' as string,
      repeatedPassword: '' as string,
      errorMessage: '' as string,
      isPeerPassword: false as boolean,
      timerId: null as number | null,
      duration: 0 as number,
      phoneNumberCode: '+886',
      phoneNumberAreaOptions: phoneAreaOptions,
      currentPageIndex: 0,
      isEnableValidation: false,
      isEnableRepeatedPasswordValidation: false,
      token: '',
      navigateToNextPage: false,
      isLoading: false
    }
  },
  computed: {
    togglePeerPasswordIcon (): string {
      return `eye${this.isPeerPassword ? '-slash' : ''}`
    },
    togglePeerPasswordInput (): string {
      return `${this.isPeerPassword ? 'text' : 'password'}`
    }
  },
  methods: {
    // this.setToken(payload) = this.$store.commit('SET_TOKEN', payload)
    ...mapMutations({ setToken: 'SET_TOKEN', setUserInfo: 'SET_USER_INFO', setCartList: 'SET_CART_LIST', setCountry: 'SET_COUNTRY' }),
    goToPage (pageIndex: number) {
      this.navigateToNextPage = pageIndex > this.currentPageIndex
      this.currentPageIndex = pageIndex
      this.clearForm()
    },
    toggleTimer (enabled: boolean, time: number) {
      // Cold down for send validation code again
      if (enabled) {
        this.duration = time
        if (!this.timerId) {
          this.timerId = setInterval(() => {
            this.duration -= 1
            if (this.duration === 0) {
              if (this.timerId) { clearInterval(this.timerId) }
              this.timerId = null
            }
          }, 1000)
        }
      }
    },
    async handleSendValidationCode () {
      // Check the process is in the first send vcode
      if (this.transformedPhoneNumber.length === 0) {
        this.isEnableValidation = true
        if (!this.validatePhoneNumber()) {
          this.errorMessage = '請輸入正確的手機格式'
          return
        }
      }

      this.transformedPhoneNumber = this.transformPhoneNumberByArea(this.phoneNumberCode)

      try {
        const register = this.isRegister ? '1' : '0'

        const requestBody: ISendVCodeRequest = {
          uphone: this.transformedPhoneNumber,
          register
        }
        const { data } = await sendValidationCode(requestBody)

        switch (data.flag) {
          case 0:
            // success
            this.toggleTimer(true, 99)
            this.goToPage(1)
            return
          case 2:
            if (this.duration === 0) { this.duration = 99 }
            this.$bvModal.msgBoxOk(`您已要求送出驗證簡訊，請等候 ${this.duration} 秒後才能再次發送。`, {
              centered: true,
              footerClass: 'msgbox-ok-footer',
              okTitle: '確定'
            }).then(() => {
              this.toggleTimer(true, data.duration)
            })
            return
          case 1:
          default:
            this.$bvModal.msgBoxOk(data.msg, {
              centered: true,
              footerClass: 'msgbox-ok-footer',
              okTitle: '確定'
            }).then(() => {
              this.toggleTimer(true, data.duration)
            })
            return
        }
      } catch (error) {
        this.$bvModal.msgBoxOk(error, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
    },
    async handleCheckValidationCode () {
      this.isEnableValidation = true
      if (this.vcode.length === 0) {
        this.errorMessage = '請輸入驗證碼'
        return
      }

      try {
        const requestBody: ICheckVCodeRequest = {
          uphone: this.transformedPhoneNumber,
          vcode: this.vcode
        }

        const { data } = await checkValidationCode(requestBody)
        if (data.flag === 1) {
          throw data.msg
        } else {
          this.token = data.token_info.token
          this.goToPage(2)
        }
        return
      } catch (error) {
        this.$bvModal.msgBoxOk(error, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
    },
    async handleSetPassword () {
      this.isEnableValidation = true
      if (!this.validateRegisterPassword()) {
        this.errorMessage = '密碼需包含大小寫英數字8碼以上'
        return
      }
      if (!this.validateRegisterRepeatedPassword()) {
        this.errorMessage = '輸入的密碼不一致'
        return
      }

      this.isLoading = true
      try {
        if (this.isRegister) {
          const requestBody: Auth.ISetPasswordRequest = {
            account: this.transformedPhoneNumber,
            upass: this.password,
            token: this.token
          }

          const { data } = await setPassword(requestBody)
          if (data.flag === 1) {
            throw data.msg
          } else {
            this.$store.commit('logger/PUSH_LOG', `Phone register: ${JSON.stringify(data)}`)
            const loginRequestBody = {
              account: this.transformedPhoneNumber,
              upass: this.password,
              type: '0'
            } as ILoginRequest

            const response = await loginWithUserPhone(loginRequestBody)
            const payload = response.data
            if (payload.flag === 1) {
              throw payload.msg
            } else {
              this.$store.commit('logger/PUSH_LOG', `Phone login at register: ${JSON.stringify(data)}`)
              this.setToken(payload)
              this.setUserInfo({
                account: this.transformedPhoneNumber,
                expireTime: payload.expire_time
              })
              if (this.$store.getters.country === null) {
                this.setCountry(getCountryCodeByPhoneCode(this.phoneNumberCode))
              }
              this.setCartList(null)

              // Facebook Pixel
              fbTrack('CompleteRegistration', { value: 0, currency: 'USD' })
              this.isLoading = false
              this.$bvModal.msgBoxOk('註冊成功', {
                centered: true,
                footerClass: 'msgbox-ok-footer',
                okTitle: '確定'
              }).then(
                () => this.$router.push({ path: this.redirect || '/' })
              )
            }
          }
        } else {
          const requestBody: Auth.IChangePasswordRequest = {
            account: this.transformedPhoneNumber,
            new_upass: this.password,
            token: this.token
          }

          const { data } = await changePassword(requestBody)
          if (data.flag === 1) {
            throw data.msg
          } else {
            const requestBody = {
              account: this.transformedPhoneNumber,
              upass: this.password,
              type: '0'
            } as ILoginRequest

            const { data } = await loginWithUserPhone(requestBody)
            if (data.flag === 1) {
              throw data.msg
            } else {
              this.setToken(data)
              this.setUserInfo({
                account: this.transformedPhoneNumber,
                expireTime: data.expire_time
              })
              this.clearForm()
              this.isLoading = false
              this.$bvModal.msgBoxOk('修改密碼成功', {
                centered: true,
                footerClass: 'msgbox-ok-footer',
                okTitle: '確定'
              }).then(
                () => this.$router.push({ path: this.redirect || '/' })
              )
            }
          }
        }
      } catch (error) {
        this.isLoading = false
        this.$bvModal.msgBoxOk(error.message, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
    },
    transformPhoneNumberByArea (phoneNumberCode: string) {
      if (phoneNumberCode === '+886') {
        this.phoneNumber = this.phoneNumber.replace(/^\+?886/, '')
        if (this.phoneNumber.charAt(0) === '9') {
          this.phoneNumber = this.phoneNumber.padStart(10, '0')
        }
        return this.phoneNumber
      } else {
        return phoneNumberCode.concat(this.phoneNumber)
      }
    },
    validatePhoneNumber (): boolean | null {
      if (!this.isEnableValidation) return null
      const phoneNumber = this.phoneNumber
      if (!phoneNumber.match(/^\d+$/)) { return false }
      switch (this.phoneNumberCode) {
        case '+886':
          return phoneNumber.length === 10 && /^09/.test(phoneNumber)
        case '+86':
          return phoneNumber.length === 11
        case '+852':
        case '+853':
        case '+65':
          return phoneNumber.length === 8
        default:
          return false
      }
    },
    validateRegisterPassword (): boolean | null {
      if (!this.isEnableValidation) return null
      const reg = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!#$%&*+,-./:;<>?@\\^_{|}~]{8,}$/)
      return reg.test(this.password)
    },
    validateRegisterRepeatedPassword (): boolean | null {
      return this.isEnableRepeatedPasswordValidation ? this.password === this.repeatedPassword && this.repeatedPassword.length > 0 : null
    },
    isEmpty (target: string): boolean {
      return (target.length === 0 || !target.trim())
    },
    clearForm () {
      this.phoneNumber = ''
      this.errorMessage = ''
      this.password = ''
      this.isPeerPassword = false
      this.isEnableValidation = false
      this.isEnableRepeatedPasswordValidation = false
    },
    slideAnimationDirecton (next: boolean): string {
      return next ? 'slide-left' : 'slide-right'
    },
    onRegisterPasswordChanged () {
      this.isEnableValidation = true
      this.errorMessage = this.validateRegisterPassword() ? '' : '密碼需包含大小寫英數字8碼以上'
    },
    displayDidNotReceiveVCodeModal () {
      const message = '請確認手機號碼正確，也可能是此手機號碼已停用商業簡訊，請洽電信公司開啟接收商業簡訊功能或使用其他手機門號。\n電信客服手機直撥 中華電信：123 遠傳：123 台灣大哥大：188 亞太：999 台灣之星：123'
      this.$bvModal.msgBoxOk(message, {
        centered: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      })
    }
  }
})
